import * as React from "react";
import { HabitPrescriptionItemRequest } from "@curefit/gmf-common";
import { IPatientConcern } from "@curefit/ehr-common";
import {default as AppUtils, EpochConstants, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash"
import ModelFactory from "../../models/ModelFactory"
import IEditedBy from "../../models/IEditedBy";
import IStaticData from "../../models/staticData/IStaticData";
import {PatientHabitsPlansEditorProps} from "../../components/patient/edit/HabitsPlanEditor";
import IHabitsPrescription from "../../models/IHabitsPrescription";
import {HabitsPlanViewProps} from "../../components/patient/view/HabitsPlanView";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import {AppConstants} from "../../utils/AppConstants";
import {IHabitListItem, IHabits} from "../../models/LCPlanClientModels";

/**
 * Created by aditya on 28/02/18.
 */

export interface HabitsPlanEditViewContProps {
    editedBy: IEditedBy,
    patientId: number,
    secondaryPatientId: string,
    patientHabitsPlan: IHabits,
    displayMode?: EditViewDisplayMode,
    fetchPatientFitnessPlan?: (patientId: number) => any,
    savePatientFitnessPlan?: (patientId: number, patientFitnessPlans: IPatientConcern[]) => any
    fetchFitnessActivities?: (input: string) => Promise<any>;
    staticLifestyleHabits: IStaticData;
    isSelf: boolean;
    consultationId: number
}

export interface HabitsPlanEditViewContState {
    updatedHabitPlans: {item: IHabitListItem}[],
    isPatientHabitsPlanDataLoaded: LOADING_STATE
}

class HabitsPlanEditViewCont extends React.Component<HabitsPlanEditViewContProps, HabitsPlanEditViewContState> {

    constructor(props: HabitsPlanEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: HabitsPlanEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedConcernsFromProps = (props: HabitsPlanEditViewContProps): {item: HabitPrescriptionItemRequest}[] => {
        let currUpdatedConcerns: {item: HabitPrescriptionItemRequest}[] = [];
        _.map(props.patientHabitsPlan, function(concern){
            let clonePatientConcern = Object.assign({}, concern);
            currUpdatedConcerns.push({item: clonePatientConcern});
        });
        return currUpdatedConcerns;
    }

    getStateFromProps = (props: HabitsPlanEditViewContProps) => {
        let currState: HabitsPlanEditViewContState = {
            updatedHabitPlans: [],
            isPatientHabitsPlanDataLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( _.isNull(props.patientHabitsPlan) ) {
            props.fetchPatientFitnessPlan(this.props.patientId);
            currState.isPatientHabitsPlanDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedHabitPlans = [];
            if (!_.isEmpty(props.patientHabitsPlan)) {
                _.map(props.patientHabitsPlan.habitList, (patientConcern: IHabitListItem) => {
                    currState.updatedHabitPlans.push({item: patientConcern});
                });
            }
            currState.isPatientHabitsPlanDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getHabitPlanEditViewTemplateProps = () => {
        let patientFitnessPlanViewProps: HabitsPlanViewProps = {
            patientHabitsPlan: this.props.patientHabitsPlan
        };
        let patientFitnessPlanEditorProps: PatientHabitsPlansEditorProps = {
            fetchFitnessActivities: this.props.fetchFitnessActivities,
            updatedHabitPlans: this.state.updatedHabitPlans,
            updateHabitPlans: this.updatePatientFitnessPlan,
            staticLifestyleHabits: this._getFilteredStaticLifestyleHabits(),
        }
        return {"view": patientFitnessPlanViewProps, "edit": patientFitnessPlanEditorProps};
    }

    _getFilteredStaticLifestyleHabits = () => {
        if (!_.isEmpty(this.props.staticLifestyleHabits)) {
            let copiedStaticData = AppUtils.getDeepCopiedObject(this.props.staticLifestyleHabits);
            let {values} = copiedStaticData;
            let alreadyFilledHabits: string[] = [];
            this.state.updatedHabitPlans.forEach(habitItem => {
                if (!_.isEmpty(habitItem.item) && !_.isEmpty(habitItem.item.dailyHabit)) {
                    alreadyFilledHabits.push(habitItem.item.dailyHabit.internalValue);
                }
            });
            const keywords = !_.isEmpty(alreadyFilledHabits) ? alreadyFilledHabits.filter(habit => AppUtils.isDefined(habit)).map(item => item.split("_").slice(1, 2).join("_")) : [];
            copiedStaticData.values = values.filter((dataItem: IStaticDataValue) => {
                const dataItemKeyword = dataItem.internalValue.split("_").slice(1, 2).join("_");
                return keywords.indexOf(dataItemKeyword) < 0;
            });
            return copiedStaticData;
        } else {
            return this.props.staticLifestyleHabits
        }

    }

    updatePatientFitnessPlan = (updatedHabitPlans: {item: IHabitListItem}[]) => {
        this.setState({updatedHabitPlans});
    }

    savePatientFitnessPlan = () => {
        let myInstance = this;
        let saveConcernsList: HabitPrescriptionItemRequest[] = this.getSaveObject();
        if (saveConcernsList.length > 0) {
            this.setState({isPatientHabitsPlanDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            this.props.savePatientFitnessPlan(this.props.patientId, saveConcernsList).then(function(){
                myInstance.setState({isPatientHabitsPlanDataLoaded: LOADING_STATE.LOADED})
            });
        }
    }

    cancelActionHandler = () => {
        this.setState({updatedHabitPlans: this.getUpdatedConcernsFromProps(this.props)});
    }

    isFormDirty = (): boolean => {
        let status = false;
        let erronousRows: number[] = [];
        _.map(this.state.updatedHabitPlans, function(updatedHabitPlanItem: {item: IHabitListItem}, index: number){
            if (!ModelFactory.isValidHabitsPlanItem(updatedHabitPlanItem.item)) {
                status = true;
                erronousRows.push(index + 1);
                return false;
            }
        })
        return status;
    }

    dirtyFormText = (): string => {
        let erronousRows: number[] = [];
        _.map(this.state.updatedHabitPlans, function(updatedHabitPlanItem: {item: IHabitsPrescription}, index: number){
            if (!ModelFactory.isValidHabitsPlanItem(updatedHabitPlanItem.item)) {
                erronousRows.push(index + 1);
                return false;
            }
        })
        let errorText = `Missing habit name in row ${erronousRows.join(", ")}`;
        return errorText;
    }

    getSaveObject = (): IHabits => {
        let saveHabitsList: IHabits = {
            habitList: _.map(this.state.updatedHabitPlans, (updatedConcernItem: {item: IHabitListItem}) => updatedConcernItem.item),
            referenceId: this.props.consultationId.toString()
        };
        return saveHabitsList;
    }

    render() {
        let isConcernDataLoaded =  this.state.isPatientHabitsPlanDataLoaded === LOADING_STATE.LOADED;
        return (
            <div className="habits-plan-editview-cont">
                {
                    isConcernDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Habits"} templateName={"habitsPlan"}
                                  templateProps={this.getHabitPlanEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientFitnessPlan}
                                  cancelActionHandler={this.cancelActionHandler}
                                  displayMode={this.props.displayMode}
                    />
                }
                {
                    !isConcernDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default HabitsPlanEditViewCont